import { createAction, props } from '@ngrx/store';

export const LoadAuthState = '[Auth] load auth state from storage';
export const ResetAuthState = '[Auth] reset auth state';
export const UpdateAuthState = '[Auth] update auth state';

export const loadAuthState = createAction(LoadAuthState);
export const resetAuthState = createAction(ResetAuthState);
export const updateAuthState = createAction(UpdateAuthState, props<{ guid: string }>());
